import React from 'react'

const ViewOrderSummary = ({ orderSummary }) => {

    // Flatten: one row per productItem, carrying parent product info along
    const flattenedItems = (orderSummary || []).flatMap((product) =>
        (product.productItems && product.productItems.length > 0)
            ? product.productItems.map((item) => ({
                ...item,
                productName: product.productName,
                markName: product.markName,
            }))
            : []
    );

    return (
        <>
            <div className="card-header">
                <h1>Order Summary</h1>
            </div>
            <div className="card-body">
                <div className="table-responsive order-summary-table">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>Mark</th>
                                <th>Model</th>
                                <th>Quote Quantity</th>
                                <th>LPO Quantity</th>
                                <th>List Price</th>
                                <th>Unit Price</th>
                                <th>Released Quantity</th>
                                <th>Total Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            {flattenedItems.length > 0 ? (
                                flattenedItems.map((item) => (
                                    <tr key={item.id}>
                                        <td>{item.markName || '-'}</td>
                                        <td>{item.productName || '-'}</td>
                                        <td>{item.quoteQuantity || 0}</td>
                                        <td>{item.lpoQuantity || 0}</td>
                                        <td>{item.listPrice ?? '-'}</td>
                                        <td>{item.unitPrice ?? '-'}</td>
                                        <td>{item.releasedQuantity || 0}</td>
                                        <td>{item.totalPrice ?? '-'}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="8" className="text-center">No orders found</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}

export default ViewOrderSummary